import { Component, OnInit } from '@angular/core';
import { ScaleDataSectionComponent } from 'app/reports/models/scale-list-data-component';
import { AssessmentResult } from 'app/shared/models/assessment-result';
import { Variable } from 'app/reports/models/variable';
import { ScaleResult } from 'app/shared/models/scale-result';
import { Question } from 'app/shared/models/question';
import { QuestionActionService } from 'app/reports/services/question-action.service';
import { ScaleResultQuestionFinderService } from 'app/reports/services/scale-result-question-finder.service';

@Component({
  selector: 'dac-question-action-list',
  templateUrl: './question-action-list.component.html',
  styleUrls: ['./question-action-list.component.scss']
})
export class QuestionActionListComponent extends ScaleDataSectionComponent implements OnInit {
  
  private _questionActions: any;
  private _questionsByScale: any;
  private _title:string;
  

  constructor(private questionActionService:QuestionActionService, private questionFinder:ScaleResultQuestionFinderService) { 
    super();
    this._questionsByScale = {};
    this._questionActions = {};
  }

  ngOnInit() {
  }

  public setReportData(data:any, results:AssessmentResult[], variables:Variable[]) {
    super.setReportData(data, results, variables);

    this._title = data.title || "Questions";

    let questionById = this.AssessmentResult.assessment.getQuestionsListById();
    this._questionActions = {};
    (data.tableActions || []).forEach(ta => {
      let question = questionById[ta.questionId] || {};

      this._questionActions[ta.questionId] = {
        scale: question.scale
        ,question: question
        ,action: ta.action
        ,label: data.tableActionLabel
        ,data: ta.data
      };
    });

    this._questionsByScale = {};
    this.ScaleResults.forEach(sr => {
      this._questionsByScale[sr.scale.id] = this.questionFinder.getQuestionsForScaleResult(this.AssessmentResult, sr);
    })
  }

  getTitle() {
    return this._title;
  }

  public getQuestionsForScaleResult(scaleResult:ScaleResult) {
    // 
    if (this._questionsByScale[scaleResult.scale.id]) {
      return this._questionsByScale[scaleResult.scale.id];
    }
    return [];
  }

  getActionLabel(question:Question) {
    if (this._questionActions[question.id]) {
      return this._questionActions[question.id].label;
    }
    return "";
  }

  hasAction(question:Question) {
    return this._questionActions[question.id] !== undefined;
  }

  handleAction(question:Question) {
    let questionAction = this._questionActions[question.id];
    if (questionAction) {
      this.questionActionService.handleAction(questionAction);
    }
    else {
      console.error("handleAction called with question " + question.id + " and no action found for it ");
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/reports/report-items/question-action-list/question-action-list.component.ts